export default __webpack_public_path__ + "static/media/DiggingDirt_02.cc6c903b.png";